<template>
<v-app v-bind:class="{ condensed: condensed, touch: isTouch, xsOnly: $vuetify.breakpoint.xsOnly, smAndUp: $vuetify.breakpoint.smAndUp, mdAndUp: $vuetify.breakpoint.mdAndUp, lgAndUp: $vuetify.breakpoint.lgAndUp, xlAndUp: $vuetify.breakpoint.xlAndUp, mdAndDown: $vuetify.breakpoint.mdAndDown, lgAndDown: $vuetify.breakpoint.lgAndDown }">
<app-notifications></app-notifications>
<v-toolbar
      app
      fixed
      dark
      color="mutedprimary"
      class="main-nav px-0"
      flat
      :height="condensed ? 40 : 50"
    >
      <router-link data-v-step="logo" to="/" tag="div">
        <div class="menu-logo">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400.14 400" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><g transform="matrix(.956921 0 0 .983274 204.834 268.684)"><circle transform="translate(-4.979 -69.852)" r="188.924"/><g transform="matrix(.771251 0 0 .771252 -104.16 -168.233)" fill="#fff"><rect width="28.35" height="255.12" rx="0" ry="0"/><rect width="28.35" height="255.12" rx="0" ry="0" transform="translate(57.09)"/><rect width="28.35" height="255.12" rx="0" ry="0" transform="translate(114.18)"/><rect width="28.35" height="255.12" rx="0" ry="0" transform="translate(169.77)"/><rect width="28.35" height="255.12" rx="0" ry="0" transform="translate(226.86)"/></g></g></svg>        </div>
      </router-link>
      <v-spacer></v-spacer>
      <router-link to="/settings/billing" class="pr-4 caption white--text" v-if="group.subscription.status === 'trial'">Trial ends in {{formatDateDifferenceInDays(group.subscription.current_period_end)}} days</router-link>
      <router-link to="/settings/billing" class="mr-4 caption white--text error px-3 py-1" style="border-radius:20px;" v-if="group.subscription.status === 'pastDue'">Update your payment method</router-link>
      <div class="menu-nav-icon" :class="{ dot: showNotificationDot }" @click.stop="rightDrawer = !rightDrawer">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400.14 400" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><g transform="matrix(.956921 0 0 .983274 204.834 268.684)"><circle transform="translate(-4.979 -69.852)" r="188.924"/><g transform="matrix(.771251 0 0 .771252 -104.16 -168.233)" fill="#fff"><rect width="28.35" height="255.12" rx="0" ry="0"/><rect width="28.35" height="255.12" rx="0" ry="0" transform="translate(57.09)"/><rect width="28.35" height="255.12" rx="0" ry="0" transform="translate(114.18)"/><rect width="28.35" height="255.12" rx="0" ry="0" transform="translate(169.77)"/><rect width="28.35" height="255.12" rx="0" ry="0" transform="translate(226.86)"/></g></g></svg>      </div>
    </v-toolbar>

    <v-content>
      <!-- we use stoptour here to listen to the emit from the intro component -->
      <router-view @stopTour="stopTour"/>
    </v-content>
    <v-navigation-drawer
      temporary
      right
      v-model="rightDrawer"
      fixed
      app
      dark
      class="navdrawer"

    >
      <v-layout align-center>
        <v-flex grow>
          <div class="body-2 white--text" style="padding:30px 20px;">{{group.title}}</div>
        </v-flex>
        <v-flex shrink>
          <div class="menu-nav-icon close mr-3" @click="rightDrawer = !rightDrawer"><svg class="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"/></svg></div>
        </v-flex>
      </v-layout>
    <v-list class="pt-0" dense>
      <v-divider></v-divider>
      <v-list-tile
      router
      to="/"
      exact
      active-class="default-class menu-current"
      >
        <v-list-tile-action>
          <div class="projicon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 255.21 255.12"><title>Logo</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="line" width="28.35" height="255.12"/><rect class="line" x="57.09" width="28.35" height="255.12"/><rect class="line" x="114.18" width="28.35" height="255.12"/><rect class="line" x="169.77" width="28.35" height="255.12"/><rect class="line" x="226.86" width="28.35" height="255.12"/></g></g></svg></div>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="body-2">Work organiser</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
      v-for="item in items"
      :key="item.title"
      router
      :to="item.link"
      :exact="item.exact"
      active-class="default-class menu-current"
      >
        <v-list-tile-action>
          <v-icon class="body-4">{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="body-2">
            {{ item.title }}
            <span class="notifications-badge" v-if="(item.title === 'Notifications') && notificationUnreadCount > 0">
              {{notificationUnreadCount}}
            </span>
        </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile
      to="/support"
      active-class="default-class menu-current"
      >
        <v-list-tile-action>
          <v-icon>help_outline</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="body-2" data-v-step="support">Help &amp; support</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="onLogout" >
        <v-list-tile-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="body-2" data-v-step="menu">Logout</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
  <intro-modal v-if="!introDone" @start-tour='startTour'></intro-modal>
  <!-- <intro-modal @start-tour='startTour'></intro-modal> -->
  <dash-tour ref="dashTour" @toggleDrawer="toggleDrawer"></dash-tour>
  <!--<matched-transactions></matched-transactions>-->
  <!-- service worker update notification -->
  <v-snackbar
        v-model="snackWithButtons"
        :timeout="timeout"
        bottom
        left
        class="noborder"
      >
        {{ snackWithBtnText }}
        <v-spacer />
        <v-btn
          dark
          color="accent"
          @click.native="refreshApp"
        >
          {{ snackBtnText }}
        </v-btn>
        <v-btn
          icon
          @click="snackWithButtons = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
      <confirm ref="confirm"></confirm>
</v-app>
</template>

<script>
import AppNotifications from '@/components/Shared/AppNotifications'
// import MatchedTransactions from '@/components/Shared/MatchedTransactions'
import DashTour from '@/components/Shared/DashTour'
import IntroModal from '@/components/Dash/IntroModal'
import { formatDate } from '@/components/Mixins/formatDate'
import Confirm from '@/components/Shared/Confirm'

export default {
  components: {
    AppNotifications,
    IntroModal,
    // MatchedTransactions,
    DashTour,
    Confirm
  },
  mixins: [formatDate],
  data () {
    return {
      rightDrawer: false,
      items: [
        { title: 'Invoices', icon: 'local_atm', link: '/invoices', exact: false },
        { title: 'Quotes', icon: 'receipt', link: '/quotes', exact: false },
        // { title: 'Expenses', icon: 'receipt', link: '/expenses', exact: false },
        { title: 'Clients', icon: 'group', link: '/clients', exact: false },
        { title: 'Repeat jobs', icon: 'sync', link: '/repeat-jobs', exact: false },
        { title: `Notifications`, icon: 'notifications', link: '/notifications', exact: false },
        { title: `Archive`, icon: 'restore', link: '/archive', exact: false },
        { title: 'Settings', icon: 'settings', link: '/settings', exact: false }
      ],
      introDone: this.$store.getters.group.introDone || false,
      showEnvTag: true,
      refreshing: false,
      registration: null,
      snackBtnText: '',
      snackWithBtnText: '',
      snackWithButtons: false,
      timeout: 0,
      barHeight: 50
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    group () {
      return this.$store.getters.group
    },
    loading () {
      return this.$store.getters.loading
    },
    showEnv () {
      const env = process.env.VUE_APP_ENVIRONMENT
      if (env === 'production') {
        return null
      }
      return env
    },
    isAuthorised () {
      if ((this.group.subscription.status === 'suspended') || (this.group.subscription.status === 'trialExpired')) {
        return false
      } else {
        return true
      }
    },
    condensed () {
      if (this.$vuetify.breakpoint.lgAndUp && !this.isTouch) {
        return true
      }
      return false
    },
    isTouch () {
      return ('ontouchstart' in window) ||
                   (navigator.maxTouchPoints > 0) ||
                   (navigator.msMaxTouchPoints > 0)
    },
    bp () {
      return this.$vuetify.breakpoint.name
    },
    notificationUnreadCount () {
      return this.$store.getters.notificationUnreadTotal
    },
    showNotificationDot () {
      if (this.notificationUnreadCount > 0) {
        return true
      }
      return false
    }
  },
  watch: {
    user (value) {
      if (value === null || value === undefined) {
        this.$router.push('/sign-in')
      }
    },
    isAuthorised: {
      handler: function (val, oldVal) {
        if (val === false) {
          this.$router.push({ name: 'Reactivate' })
        }
      },
      immediate: true // ensures its run on default value as well as subsequent changes
    }
  },
  methods: {
    onLogout () {
      this.$store.dispatch('logout')
    },
    startTour () {
      this.$refs.dashTour.startTour()
    },
    stopTour () {
      // called from the Board component when leaving the route to ensure we dont keep showing the tour if we navigate away
      this.$refs.dashTour.stopTour()
    },
    toggleDrawer (state) {
      this.rightDrawer = state
    },
    showRefreshUI (e) {
      this.registration = e.detail
      this.snackBtnText = 'Refresh'
      this.snackWithBtnText = 'New version available!'
      this.snackWithButtons = true
    },
    refreshApp () {
      this.snackWithButtons = false
      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) { return }
      this.registration.waiting.postMessage('skipWaiting')
    }
  },
  created () {
    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      window.location.reload()
    })
  },
  mounted () {
    this.$root.$confirm = this.$refs.confirm
  }
}
</script>

<style lang="scss">
.menu-logo, .menu-nav-icon {
  display:flex;
  cursor:pointer;
  svg{
    width:38px;
    height:38px;
    rect{
      fill:var(--green);
    }
    circle {
      transition: fill .3s;
      fill: var(--totals-button);
    }
  }
  &:hover svg circle{
      fill:#18305C;
  }
}

.condensed .menu-logo, .condensed .menu-nav-icon {
  svg{
    width:35px;
    height:35px;
  }
}
.menu-nav-icon.close{
  svg{
    width:30px;
    height:30px;
  }
}
.menu-nav-icon{
  transform:rotate(90deg);
  svg{
    rect, path{
      fill:#fff;
    }
  }
}
.menu-nav-icon.dot:after{
    // transform:rotate(0deg);
    position: absolute;
    top:23px;
    left: 0px;
    width:10px;
    height:10px;
    padding: 0px;
    border-radius: 100%;
    background: var(--red);
    color: white;
    content:' ';
    z-index:10;
}
.notifications-badge{
    // position:absolute;
    // top:0px;
    // left: 0px;
    display:inline-block;
    text-align:center;
    width:25px;
    margin-left:10px;
    // font-size: .9rem;
    // height:15px;
    padding: 0px;
    border-radius: 100%;
    background: var(--red);
    color: white;
    z-index:10;
}
.projicon{
  padding:6px;
  width:30px;
  height:30px;
  svg{
    width:14px;
    height:14px;
    rect{
      fill:#fff;
    }
  }
}
.menu-current .projicon svg rect {
  fill:var(--green);
}
.main-nav{
  background-color:var(--primary);
}
.main-nav .v-toolbar__content {
  height:50px !important;
}
.condensed .main-nav .v-toolbar__content{
  height:40px !important;
}
.theme--dark.v-navigation-drawer.navdrawer{
    background-color:var(--mutedprimary);

}

.btn:not(.btn--flat){
  box-shadow: inset 0 0 0 1px rgba(0, 0, 20, 0.1);
  text-transform:capitalize;
  font-weight:700;
  &.accent{
  background-image: linear-gradient(var(--button-gradient-start-green), var(--green));
  }
  &.error{
    background: var(--red);
  }
}
.menu-current.v-list__tile--active{
  color:var(--green) !important;
  opacity:1;
}

.v-snack__wrapper {
  box-shadow:none;
  border-radius:0;

}
.v-snack__content {
    border-width: 4px 0 0 0;
        border-style: solid;
  border-color: rgba(0,0,0,0.12) !important;
  .noborder & {
    border:0;
  }
}
// .v-step__arrow{
//   border-color:var(--primary) !important;
// }

</style>
